/*global angular */
/*global window */
/*global document */
/*global navigator */
/*global G_vmlCanvasManager */
/*jslint node: true */

'use strict';

var feedbackAgent = angular.module('msFeedbackAgent', []);

feedbackAgent.service('msFeedbackAgent', ['$compile', '$templateCache', '$mdDialog', 'msExt', '$http', 'site', function ($compile, $templateCache, $mdDialog, msExt, $http, site) {
    var context;
    var canvas;
    var enabled = false;
    var paint = false;
    var clickX = [];
    var clickY = [];
    var clickDrag = [];
    var scaleFactor;
    var stoppedDrawingCallback;

    function resetVars() {
        context = null;
        canvas = null;
        enabled = false;
        paint = false;
        clickX = [];
        clickY = [];
        clickDrag = [];
        scaleFactor = 0;
        stoppedDrawingCallback = null;
    }

    function addClick(e, dragging) {
        var rect = canvas.getBoundingClientRect();
        var x = (e.pageX - rect.left) * scaleFactor;
        var y = (e.pageY - rect.top) * scaleFactor;

        var lastClickX, lastClickY;
        if (clickX.length > 0) {
            lastClickX = clickX[clickX.length-1];
            lastClickY = clickY[clickY.length-1];
            if (Math.abs(x - lastClickX) < 3 && Math.abs(y - lastClickY) < 3) {
                return;
            }
        }
        clickX.push(x);
        clickY.push(y);
        clickDrag.push(dragging);
    }

    function redraw() {
        context.strokeStyle = "#df4b26";
        context.lineJoin = "round";
        context.lineWidth = 8;

        var si= clickX.length-2;
        if (si<0) si = 0;

        for(var i=si; i < clickX.length; i++) {
            context.beginPath();
            if (clickDrag[i] && i){
                context.moveTo(clickX[i-1], clickY[i-1]);
            } else {
                context.moveTo(clickX[i]-1, clickY[i]);
            }
            context.lineTo(clickX[i], clickY[i]);
            context.closePath();
            context.stroke();
        }
    }

    var msFeedbackAgent = {
        eventListenerNames: {
            mousedown: function(e){
                paint = true;
                addClick(e);
                redraw();
            },
            touchstart: function(e){
                paint = true;
                addClick(e);
                redraw();
                e.preventDefault();
            },
            touchmove: function(e){
                if(paint){
                    addClick(e, true);
                    redraw();
                }
                e.preventDefault();
            },
            mousemove: function(e){
                if(paint){
                    addClick(e, true);
                    redraw();
                }
            },
            mouseup: function(e){
                paint = false;

                stoppedDrawingCallback && stoppedDrawingCallback();
            },
            touchend: function(e){
                paint = false;
                e.preventDefault();

                stoppedDrawingCallback && stoppedDrawingCallback();
            },
            mouseleave: function(e){
                paint = false;

                stoppedDrawingCallback && stoppedDrawingCallback();
            },
            touchleave: function(e){
                paint = false;
                e.preventDefault();

                stoppedDrawingCallback && stoppedDrawingCallback();
            }
        },

        reset: resetVars,

        enableDrawing: function(_canvas) {
            if (!_canvas) {
                return;
            }

            canvas = _canvas;

            if (typeof G_vmlCanvasManager != 'undefined') {
                canvas = G_vmlCanvasManager.initElement(canvas);
            }

            scaleFactor = canvas.width / canvas.offsetWidth;

            context = canvas.getContext("2d");

            angular.forEach(this.eventListenerNames, function (eventListener, eventName) {
                canvas.addEventListener(eventName, eventListener);
            });
        },
        disableDrawing: function(_canvas) {
            if (!_canvas) {
                return;
            }

            canvas = _canvas;

            angular.forEach(this.eventListenerNames, function (eventListener, eventName) {
                canvas.removeEventListener(eventName, eventListener);
            });
        },
        getBrowseName: function() {
            var N = navigator.appName, ua = navigator.userAgent, tem;
            var M = ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);
            if(M && (tem = ua.match(/version\/([\.\d]+)/i))!== null) M[2]= tem[1];
            M = M? [M[1], M[2]]: [N, navigator.appVersion,'-?'];
            return M;
        },
        takeSnapshot: function(target, call) {
            var self = this;

            html2canvas(target, { height: target.getBoundingClientRect().height, onclone: site.prepareScreenshot }).then(function(canvas) {
                var resizedCanvas = document.createElement('canvas');
                resizedCanvas.width = canvas.width / 2;
                resizedCanvas.height = canvas.height / 2;
                resizedCanvas.getContext("2d").drawImage(canvas, 0, 0, resizedCanvas.width, resizedCanvas.height);
                resizedCanvas.style.width = '100%';

                // clean big canvas
                canvas.height = 0;
                canvas.width = 0;

                call(resizedCanvas);
            }, function(a, b, c) {
                // todo: handle error
            });
        },
        setStoppedDrawingCallback: function(c) {
            stoppedDrawingCallback = c;
        }
    };

    return {
        injectDirective: function (scope, _element) {
            if (!scope.mode.edit) return;

            var page = _element[0];
            scope.feedbackbutton = { visisble: true };
            var feedbackbutton = scope.feedbackbutton;

            scope.showFeedbackDialog = function(ev) {
                scope.editing.switchMode('select');

                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', function($scope, $mdDialog) {
                        feedbackbutton.visisble = false;
                        $scope.sent = false;
                        $scope.failed = false;
                        $scope.loadingSnapshot = true;

                        var browser = msFeedbackAgent.getBrowseName();
                        var browserName = browser[0];
                        var browserVersion = browser[1];
                        var canv;

                        $scope.report = {
                            'name': '',
                            'email': '',
                            'message': '',
                            'browser': browserName + ' ' + browserVersion,
                            'screenshot': ''
                        };

                        msFeedbackAgent.takeSnapshot(document.body, function(canvas) {
                            $scope.loadingSnapshot = false;
                            $scope.$applyAsync();

                            canv = canvas;

                            function clearSnapshotElement() {
                                divForSnapshot.innerHTML = '';
                                divForSnapshot.appendChild(canvas);
                            }

                            var divForSnapshot;
                            var checkExist = setInterval(function() {
                                divForSnapshot = document.getElementById('snapshot');
                                if (divForSnapshot) {
                                    clearInterval(checkExist);
                                    clearSnapshotElement();
                                }
                            }, 100);
                        });

                        $scope.drawing = {
                            enabled: false
                        };

                        $scope.$watch('drawing.enabled', function(val) {
                            if (val) {
                                msFeedbackAgent.enableDrawing(canv);

                                $scope.drawingButtonStyle = {backgroundColor: 'red'};
                                $scope.drawingIconStyle = {color: 'white'};
                            } else {
                                msFeedbackAgent.disableDrawing(canv);

                                $scope.drawingButtonStyle = {backgroundColor: ''};
                                $scope.drawingIconStyle = {color: ''};
                            }
                        });

                        var s = $scope;

                        msFeedbackAgent.setStoppedDrawingCallback(function() {
                            s.drawing.enabled = false;
                            s.$applyAsync();
                        });

                        $scope.hide = function() {
                            $mdDialog.hide();
                        };
                        $scope.cancel = function() {
                            $mdDialog.cancel();
                        };
                        $scope.ok = function() {
                            $scope.report.screenshot = canv.toDataURL();

                            $http.post('/api/feedback', $scope.report, {headers: {'Content-Type': 'application/json'} })
                                .then(function successCallback(response) {
                                    $scope.sent = true;

                                    setTimeout(function () {
                                        $mdDialog.hide();
                                    }, 1000);
                                }, function errorCallback(response) {
                                    $scope.failed = true;

                                    setTimeout(function () {
                                        $mdDialog.hide();
                                    }, 1000);
                                });
                        };
                    }],
                    template: $templateCache.get('lib/msFeedbackAgent/dialog.html'),
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true
                })
                .then(function(answer) {
                            msFeedbackAgent.reset();

                            feedbackbutton.visisble = true;
                        }, function() {
                            msFeedbackAgent.reset();
                            feedbackbutton.visisble = true;
                        });
            };

            // render extension template
            var linkFn = $compile($templateCache.get('lib/msFeedbackAgent/feedbackButton.html'));
            var insertedElement = linkFn(scope);

            // prepend rendered extension template to the section
            setTimeout(function () {
                angular.element(page).prepend(insertedElement);
                scope.$applyAsync();
            }, 200);

            // clean up when video background is disabled
            var destroyWatch = scope.$watch('site.settings.msExt.msFeedbackAgent', function (enabled) {
                if (!enabled) {
                    insertedElement.remove();
                    destroyWatch();
                }
            });
        },
        config: {
            type: ['site'],
            title: 'Feedback',
            visible: function (context_type) {
                return context_type == 'site';
            },
            template: '<md-switch ng-model="subject.settings.msExt.msFeedbackAgent">aktivieren</md-switch>'
        },
        init: function (scope, context_element) {
            // inject msVideobackground object into the main scope to be accessible in template
            scope.msFeedbackAgent = msFeedbackAgent;
        }
    };
}]);
